import React from 'react';
import { motion } from 'framer-motion';
import { FaSeedling, FaLeaf, FaTree, FaHeart, FaGem, FaCrown } from 'react-icons/fa';

const relationshipLevels = [
  { level: 1, name: 'Nouvelle Graine', icon: FaSeedling, color: '#8BC34A', minMessages: 0 },
  { level: 2, name: 'Jeune Pousse', icon: FaLeaf, color: '#4CAF50', minMessages: 10 },
  { level: 3, name: 'Arbre en Croissance', icon: FaTree, color: '#2E7D32', minMessages: 50 },
  { level: 4, name: 'Connexion', icon: FaHeart, color: '#E91E63', minMessages: 100 },
  { level: 5, name: 'Lien Fort', icon: FaGem, color: '#9C27B0', minMessages: 200 },
  { level: 6, name: 'Âme Sœur', icon: FaCrown, color: '#FFD700', minMessages: 500 },
];

const RelationshipStatus = ({ messageCount, streakDays }) => {
  const currentLevel = relationshipLevels
    .slice()
    .reverse()
    .find(level => messageCount >= level.minMessages) || relationshipLevels[0];
  
  const nextLevel = relationshipLevels.find(level => level.minMessages > messageCount);
  const progress = nextLevel 
    ? ((messageCount - currentLevel.minMessages) / (nextLevel.minMessages - currentLevel.minMessages)) * 100
    : 100;

  const Icon = currentLevel.icon;

  return (
    <motion.div 
      className="relationship-status"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
    >
      <div className="relationship-header">
        <h3>Niveau de Connexion</h3>
        {streakDays > 0 && (
          <div className="streak-badge">
            <span className="fire-icon">🔥</span>
            <span>{streakDays} jours</span>
          </div>
        )}
      </div>
      
      <div className="relationship-level" style={{ '--level-color': currentLevel.color }}>
        <motion.div 
          className="level-icon-wrapper"
          animate={{ 
            scale: [1, 1.1, 1],
            rotate: [0, 5, -5, 0]
          }}
          transition={{ repeat: Infinity, duration: 3 }}
        >
          <Icon className="level-icon" />
        </motion.div>
        
        <div className="level-info">
          <h4 className="level-name">{currentLevel.name}</h4>
          <p className="level-messages">{messageCount} messages échangés</p>
        </div>
      </div>

      {nextLevel && (
        <div className="progress-section">
          <div className="progress-bar">
            <motion.div 
              className="progress-fill"
              initial={{ width: 0 }}
              animate={{ width: `${progress}%` }}
              transition={{ duration: 1, ease: "easeOut" }}
            />
          </div>
          <p className="next-level">
            Prochain niveau: <strong>{nextLevel.name}</strong> ({nextLevel.minMessages - messageCount} messages)
          </p>
        </div>
      )}

      {streakDays > 0 && (
        <motion.div 
          className="streak-celebration"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.5 }}
        >
          <p>🎉 Vous conversez depuis {streakDays} jours consécutifs !</p>
        </motion.div>
      )}
    </motion.div>
  );
};

export default RelationshipStatus;
